import React from "react";
import { Monitor } from "lucide-react";
import TableBodyCustom from "./table.body-custom";
import DataTable from "../../../../components/data-table/DataTable";

const TABLE_HEAD = [
  { id: "name", label: "Name" },
  { id: "color", label: "Colour" },
  { id: "layout", label: "Layout" },
  { id: "Status", label: "Status" },
  { id: "playlist", label: "Playlist" },
  { id: "action", label: "" },
];

// searching: a search is on, so "empty" means nothing matched.
const TableView = ({ displaydata, onEditRow, searching, isPlaylist, setIsPlayList, setDeviceId }) => (
  <DataTable
    head={TABLE_HEAD}
    isEmpty={!displaydata?.length}
    empty={
      searching
        ? { title: "Nothing matches your search", text: "Try a different word, or clear the search." }
        : {
            icon: Monitor,
            title: "No screens connected",
            text: "Add a display with the code shown on your masjid's screen.",
          }
    }
  >
    {displaydata?.map((data) => (
      <TableBodyCustom key={data?._id} data={data} onEditRow={onEditRow}
        isPlaylist={isPlaylist}
        setIsPlayList={setIsPlayList}
        setDeviceId={setDeviceId}
       />
    ))}
  </DataTable>
);

export default TableView;
